/*
* 多选下拉树工具
* 创建时间：2018/1/4
* 创建人：bxx
*/
<template>
	 <div class="form-group">
		<label class="col-sm-1 control-label">现场照片</label>
		<div class="col-sm-11 flexbox">
			<!--  @click.prevent="getMaxPic($event,picName)"  -->
			<div class="live_photo" v-for="(picName,index) in photos" :key="index" @click.prevent="getMaxPic($event,picName)">	 
				<a v-if="picName.photoStatus==2" class="thumbnail">
					<div :style="{backgroundImage:'url('+ picUrl2 + picName.logourl + ')',backgroundSize:'cover',height:'100px',width:'100px'}"></div>
					<p>{{getPhotoStatus(picName.photoStatus)}}</p>
					<span v-show="potShow" @click.stop="deletePhoto(picName.id)" class="el-icon-circle-close closebtn"></span>
				</a>
				<a v-else class="thumbnail">
					<div :style="{backgroundImage:'url('+ (picName.logourl.indexOf('http') !== -1 ? picName.logourl : picUrl + picName.logourl) + ')',backgroundSize:'cover',height:'100px',width:'100px'}" ></div>
					<p>{{getPhotoStatus(picName.photoStatus)}}</p>
					<span v-show="potShow" @click.stop="deletePhoto(picName.id)" class="el-icon-circle-close closebtn"></span>
				</a>
			</div> 
			<div>
				<button @click="addPhotos" v-show="potShow" class="btn btn-primary">现场照片</button>
					<!-- <button class="btn btn-primary">取消</button>
					<button class="btn btn-primary">确定</button> -->
			</div>
			<el-dialog title="现场照片" :closeOnClickModal='false' :modal-append-to-body="false" :visible.sync="photosVisible">
				<div class="photosBox">
					<el-form ref="photoform" :rules="photorules" :model="photoform" label-width="80px" class="demo-ruleForm">
						<el-form-item label="照片类型" prop='choseValue'>
							<el-select size="small" v-model="photoform.choseValue" placeholder="请选择">
								<el-option v-for="item in choseophotos" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="现场照片" prop='photoImages'>
							<el-upload
							class="upload-demo"
							list-type="picture-card"
							:action="photopicUrl"
							:headers="{'access-token':this.accesstoken}"
							:on-preview="photoPreview"
							:on-remove="handleRemove"
							:on-success='photosSuccess'
							:on-exceed="handleExceed"
							:before-upload="beforeupload"
							:file-list="photoslist"
							>
								<i class="el-icon-plus"></i>
								<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过400k</div>
							</el-upload>
						</el-form-item>
						
					</el-form>
					<div class="text-right">
						<button @click="photosVisible = false" class="btn btn-primary">取消</button>
						<button @click="confimbtn('photoform')" class="btn btn-primary">确定</button>
					</div>
				</div>
			</el-dialog>
			<el-dialog :append-to-body='true' :modal-append-to-body="false"  :visible.sync="photoVisible">
				<img width="100%" :src="photoImageUrl" alt="">
			</el-dialog>
		</div> 
	</div>
</template>
<script>
import {picMixin} from 'util/rescueUtil'
import classlist from 'util/classlist'
export default{
	name:'RescueOrderPics',
	mixins:[picMixin],
	props:{ 
		//救援图片数据
		photos:{
			type:Array,
			required:true
		},
		picUrl:{
			type:String,
			required:true
		},
		picUrl2:{
			type:String,
			required:true
		},
		id:{
			type:String
		},
		orderId:{
			type:Number
		},
		isphotosuccess:{
			type:Number
		},
		requestCode:{},
		reqstate:{}
	},
	computed:{
		accesstoken:function(){
			return this.$store.state.user.accesstoken
		}
	},
	data(){
		return{
		   choseValue:'',
		   choseophotos:[{label:'到达现场上传',value:0},{label:'作业救援上传',value:1}],
		   photosVisible:false,
		   photoslist: [],
		   photoform:{
			   choseValue:'',
			   photoImages:''
		   },	
		   photopicUrl:process.env.API_INSURANCE_ROOT +"/rescue-api/photo/upload",
		   photorules:{
			   choseValue: [
					{ required: true, message: '请选择照片类型', trigger: 'change' }
				],
				photoImages: [
					{ required: true, message: '请上传现场照片', trigger: 'change' }
				]
		   },
		   photoVisible:false,
		   photoImageUrl:'',
		   potShow:false
		}
	},
	mounted(){
		if(this.requestCode){
			if(this.reqstate == 2){
				this.potShow = true 
			}else{
				this.potShow = false 
			}
		}
	},
	methods:{
		getPhotoStatus(val){
			let str = ''
			switch (val){
				case 0:
					str = '到达现场上传'
					break;
				case 1:
					str = '作业救援上传'
					break;
				case 2:
					str = '视频设备抓拍'	
					break;
				case 9:
					str = '补传'
					break;
				default:
					str = ''
					break;
			}
			return str
		},
		getMaxPic(e,item){
			let idSelector = this.id
			this.showDetailPic(idSelector,e,item,classlist) 
		},
		//添加现场照片
		addPhotos(){
			this.photosVisible = true
			this.photoform.choseValue = ''
			this.photoslist = []
		},
		//
		confimbtn(formName){
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.getInfoFun()
				} else {
					return false
				}
			})
		},
		//
		getInfoFun(){
			//rescuePhotos:this.photoform.photoImages
			this.photoFun(this.photoslist)
			let params ={
				orderId:this.orderId,
				rescuePhotos:this.photoform.photoImages
			} 
			this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/insertOrderPhotos',params).then(res => {
                if (res.body.success) {
				   this.$message({type:'success',message:'上传成功'})
                   this.photosVisible = false
				   this.$emit('isphotosuccess',1)
				   this.$emit('refreshinfo','1')
                } else {
                    this.$message({type:'error',message:res.body.message || ''})
                    this.loadingorder = false
                }
            }, res => {
                tthis.$message({type:'error',message:res.body.message || ''})
                this.loadingorder = false
            })
		},
		//
		photosSuccess(res, file, fileList){
			this.photoFun(fileList)
		},
		//上传照片时
		photoFun(fileList){
			this.photoslist = fileList
			let photoArr = []
			let photoObj = {}
			for (const key in fileList) {
				photoObj={
					logourl:fileList[key].response.data,
					photoStatus:this.photoform.choseValue
				}
				photoArr.push(photoObj)
			}
			this.photoform.photoImages = photoArr
		},
		//图片放大
		photoPreview(file){
			this.photoImageUrl = file.url;
			this.photoVisible = true;
		},
		//限制图片大小
		beforeupload(file){
			const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
			const isLt1M = file.size / 1024 < 400
			if (!isLt1M) {
				this.$message.error('上传图片大小不能超过 400k!');
			}
			if (!isJPG) {
				this.$message.error('请上传png或者jpg类型的图片');
			}
			return isLt1M && isJPG
		},
		handleRemove(file, fileList) {
			this.photoslist = fileList
        	this.photoFun(fileList)
      	},
		handleExceed(files, fileList) {
			//this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		beforeRemove(file, fileList) {
			//return this.$confirm(`确定移除 ${ file.name }？`);
		},
		//删除照片
		deletePhoto(id){
			this.$confirm('是否要删除此照片?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/deletePhoto/'+id).then(res => {
                	if (res.body.success) {
				  	 this.$message({type:'success',message:'删除成功'})
					 this.$emit('refreshinfo','1')
					} else {
						this.$message({type:'error',message:res.body.message || ''})
						this.loadingorder = false
					}
				}, res => {
					this.$message({type:'error',message:res.body.message || ''})
					this.loadingorder = false
				})
			}).catch(() => {
					
			})
		}
	}	
}
</script>
<style>
.photosBox input[type="file"]{display: none;}
.photosBox .upload-demo{margin: 10px 0;}
.photosBox .el-upload-list li{width: 100px;height: 100px;}
.photosBox .el-upload--picture-card{width: 100px;height: 100px;line-height: 98px;}
.photosBox .el-date-editor.el-input{width: 100%;}
</style>
<style lang="scss" scoped>
.closebtn{position: absolute;right: 0;top: 0;font-size: 20px;color: #f5f5f5;}
.flexbox{display: flex;align-items: center;}
</style>


// WEBPACK FOOTER //
// RescueOrderPics.vue?478e3b02